import React from 'react';
import resume from '../../data/resume';
import styles from './Hero.module.css';

const Hero: React.FC = () => {
  return (
    <section id="about" className={styles.hero}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <p className={styles.greeting}>Hi, I&apos;m</p>
        <h1 className={styles.name}>{resume.name}</h1>
        <p className={styles.tagline}>
          MBA Candidate (Operations) at Chicago Booth
          <span className={styles.dot}> &middot; </span>
          Full Stack Engineer
        </p>
        <p className={styles.summary}>{resume.summary}</p>
        <div className={styles.contact}>
          <span className={styles.contactItem}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {resume.location}
          </span>
          <span className={styles.contactItem}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 5.61 5.61l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <a href={`tel:${resume.phone}`}>{resume.phone}</a>
          </span>
          <span className={styles.contactItem}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            <a href={`mailto:${resume.email}`}>{resume.email}</a>
          </span>
          <span className={styles.contactItem}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
              <rect x="2" y="9" width="4" height="12" />
              <circle cx="4" cy="4" r="2" />
            </svg>
            <a href={resume.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </span>
        </div>
        <div className={styles.ctas}>
          <a href={`mailto:${resume.email}`} className={styles.ctaPrimary}>
            Get in Touch
          </a>
          <a href="#experience" className={styles.ctaSecondary}>
            View Experience
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
